// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"141":"d57b4cfa","317":"71b438b4","416":"bf6dea44","624":"ef04f27d","667":"50fbea17"}[chunkId] + ".css";
};